import { type ChangeEvent, useEffect, useState } from 'react';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';
import classes from './ImageField.module.scss';

export default function ImageField({
  onImageSelected,
  value,
  imageWidth = 300,
  imageHeight = 225,
  ...rest
}: ImageFieldProps) {
  const [previewSrc, setPreviewSrc] = useState(value);
  useEffect(() => setPreviewSrc(value), [value]);

  const actionText = previewSrc ? 'change' : 'select';

  function onInputChanged(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    if (typeof onImageSelected === 'function') {
      onImageSelected(file);
    }

    const reader = new FileReader();
    reader.addEventListener('load', (readerEvent) => {
      if (typeof readerEvent.target?.result === 'string') {
        setPreviewSrc(readerEvent.target.result);
      } else {
        setPreviewSrc(undefined);
      }
    });
    reader.readAsDataURL(file);
  }

  return (
    <FieldWrapper component="label" {...rest} className={classes.root}>
      <div
        className={classes.imageField}
        style={{ width: imageWidth, height: imageHeight }}
      >
        {previewSrc && (
          <img
            alt="Preview"
            height={imageHeight}
            src={previewSrc}
            width={imageWidth}
          />
        )}
        <p className={classes.clickAction}>Click to {actionText} image</p>
      </div>

      <input className={classes.input} onChange={onInputChanged} type="file" />
    </FieldWrapper>
  );
}

export interface ImageFieldProps extends FieldWrapperProps {
  imageHeight?: number;
  imageWidth?: number;
  onImageSelected?(imageFile: File): void;
  value?: string;
}
